import React, {PropTypes} from "react";
import Modal from "react-bootstrap/lib/Modal";
import {Field, reduxForm} from "redux-form";
import Dates from "../../../../classes/dates";
import axios from "axios";
import toastr from "toastr";
import Checkbox from "material-ui/Checkbox";
import MenuItem from "material-ui/MenuItem";
import OverlayTrigger from "react-bootstrap/lib/OverlayTrigger";
import Popover from "react-bootstrap/lib/Popover";
import {DatePicker, SelectField, TextField} from "redux-form-material-ui";
import Constants from "../../../../classes/constants"
//import DatePicker from 'material-ui/DatePicker';
//import TextField from 'material-ui/TextField';
//import SelectField from 'material-ui/SelectField';


const Display = (props) => {

  return (
    <div>
      <table className="table table-bordered" cellPadding='0' cellSpacing='0'>
        <tbody>
        <tr>
          <td>Involuntary</td>
          <td>We have asked the employee to exit due to any reasons
            Voluntary
          </td>
        </tr>
        Employee has resigned on his/her own
        Absconding
        Employee is absent from work for more than 5 days without approval
        <tr>
          <td>hey</td>
        </tr>
        </tbody>
      </table>

    </div>
  );

}


const validate = values => {
  const errors = {};
  const requiredFields = ['doResignation', 'doLeaving', 'noticePeriodStatus', 'typeOfExit', 'status', 'remarks'];
  let d = new Dates();


  if (values['doLeaving'] == null) {
    errors['doLeaving'] = 'Required';
  }
  if (typeof(values['remarks']) == 'string')
    if (values['remarks'].trim().length == 0)
      errors['remarks'] = 'Required';

  requiredFields.forEach(field => {

    if (!values[field]) {
      errors[field] = 'Required'
    }
  });
  return errors;
};

class ModalApply extends React.Component {

  constructor() {
    super();
    this.state = {
      doR: null,
      comment: null,
      email: false,
      error: "",
      disable: false,
      gardening: true,
      showRecovery: false,
      serving: 'none', served: 'none', abscond: 'none', recover:'none', gardeningDisplay:'none', termination:'none',
        business :'none'
    }
    this.applyExit = this.applyExit.bind(this);
  }

  getRequestObject(data) {
    data.id = null;
    data.empId = this.props.employee.employeeCode;
    data.name = this.props.employee.name;
    data.doResignation = data.doResignation.getTime();
    if (data.doLeaving != null && data.doLeaving != 0) {
      data.doLeaving = data.doLeaving.getTime();
    }
    if (data.gardening != null && data.gardening != 0) {
      data.gardening = data.gardening.getTime();
    }


    data.remarks = data.remarks ? data.remarks : "";
    return data;
  }

  applyExit(data, recovery) {
  data = this.getRequestObject(data);
  let exitData = new FormData();
  exitData.append('picture', this.state.file, "image.jpg");
  exitData.append('recovery', recovery);
  exitData.append('doLeaving', data.doLeaving);
  exitData.append('doResignation', data.doResignation);
  exitData.append('empId', data.empId);
  exitData.append('gardening', null);
  exitData.append('noticePeriodStatus', data.noticePeriodStatus);
  exitData.append('remarks', data.remarks);
  exitData.append('typeOfExit', data.typeOfExit);
  let xhr = new XMLHttpRequest();
  xhr.open('POST', process.env.REQ_URL +'/exit/managerApply', true);
  xhr.responseType = 'json';
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.withCredentials = true;

  // Set up a handler for when the request finishes.
  xhr.onload = function () {
    if (xhr.status === 200) {
      this.setState({src: ""});
      this.props.close();
      this.props.refresh();
      toastr.success("Data updated")
      // File(s) uploaded.
    } else {
      alert('An error occurred!');
    }
  }.bind(this);
  xhr.send(exitData);
  }

  render() {
    const {handleSubmit, reset} = this.props;
    let exitText = "Upload respective exit employee's resignation mail screenshot / image (JPEG/PNG/PDF & < 2MB)";
    return (
      <Modal
        bsSize="large"
        show={this.props.open} onHide={this.props.close}>
        <Modal.Header closeButton>
          <Modal.Title><u>MOVE TO EXIT</u><br/>{this.props.employee.employeeCode}&nbsp;&nbsp;{this.props.employee.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form encType="multipart/form-data" onSubmit={handleSubmit(data => {
            if(!this.state.file){
             alert("Upload image");
              this.setState({error: 'Upload Image'});
              return;
            }
            if (this.state.showRecovery) {
              if (data.recovery == parseInt(data.recovery, 10) && !isNaN(data.recovery)) {
                if (data.recovery > 90) {
                  this.setState({error: 'Days should be less than 90'});
                  return;
                }
              }
              else {
                this.setState({error: "Please Enter a number"});
                return;
              }
            }
            if (this.state.showRecovery) {
              this.setState({error: ""});
              this.applyExit(data, data.recovery);
            }
            else
              this.applyExit(data, null);
          })}>
            <table style={{marginBottom: 0, width: '100%'}} className="table table-bordered">
              <thead>
              <tr>
                <th cellPadding="0" colSpan="4">
                  <span
                    className="bold pull-left">{this.props.employee.employeeCode}&nbsp;&nbsp;{this.props.employee.name}</span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td style={{color: 'black', align: 'left', width: '18%'}}>Notice Period:</td>
                <td style={{
                  fontSize: '16px',
                  align: 'left',
                  width: '28%',
                  padding: 0,
                  paddingLeft: '1%',
                  paddingTop: '1%'
                }}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                    {this.props.employee.noticePeriod ? this.props.employee.noticePeriod + "days" : ' '}
                  </span>
                </td>
                <td style={{color: 'black', align: 'left', width: '18%'}}><Checkbox
                  onCheck={()=> {
                    this.setState({showRecovery: !this.state.showRecovery})
                  }}
                  label="Recovery"
                  defaultChecked={this.props.employee.recovery != 0 && this.props.employee.recovery != null ? true : false}/>
                </td>
                <td style={{fontSize: '16px', align: 'left', padding: 0, paddingLeft: '1%', paddingTop: '0%'}}>
                  <span id="ContentPlaceHolder1_txtSpouseName" className="GenText">
                    {this.state.showRecovery ? <Field
                      name="recovery"
                      errorText={this.state.error}
                      hintText="Enter recovery period"
                      style={{width: '80%'}}
                      component={TextField}
                    /> : null}
                    </span>
                </td>
              </tr>
              <tr>
                <td style={{color: 'black', align: 'left', width: '18%'}}>Date of Resignation:</td>
                <td style={{align: 'left', width: '28%', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                     <Field name="doResignation"
                            component={DatePicker}
                            formatDate={(date)=> {
                              return (date.toString().substring(0, 16));
                            }}
                            autoOk={true}
                            textFieldStyle={{width: '100%'}}
                            defaultValue={null} // DatePicker requires an object,
                       // and redux-form defaults to ''
                            hintText="Date of Resignation "/>
                  </span>
                </td>
                <td style={{color: 'black', align: 'left', width: '18%'}}>Last Working Day:</td>
                <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtSpouseName" className="GenText">
                    <Field name="doLeaving"
                           fullWidth={true}
                           component={DatePicker}
                           formatDate={(date)=> {
                             return (date.toString().substring(0, 16));
                           }}
                           autoOk={true}
                           textFieldStyle={{width: '100%'}}
                           defaultValue={null} // DatePicker requires an object,// and redux-form defaults to ''
                           hintText="Last Working Day"/>
                    </span>
                </td>
              </tr>
              <tr>
                <td style={{color: 'black', align: 'left', width: '18%'}}>
                  <OverlayTrigger trigger={['hover', 'focus']} placement="top"
                                  overlay={ <Popover
                                    style={{width: '500px', borderStyle: 'solid'}}
                                    id="popover-trigger-hover-focus">
                                    <ul style={{paddingLeft: 0, marginLeft: 10}}>
                                      <li><u><b>Involuntary:</b></u>&nbsp; We have asked the employee to exit due to any
                                        reason
                                      </li>
                                      <li><u><b>Voluntary:</b></u>&nbsp; Employee has resigned on his/her own</li>
                                      <li><u><b>Absconding:</b></u>&nbsp; Employee is absent from work for more than 5
                                        days without approval
                                      </li>
                                    </ul>

                                  </Popover>}>
                    <div>
                      Type Of Exit:
                      <img src="public/images/help.svg" style={{marginLeft: '5px'}} height="18px" width="18px"/></div>
                  </OverlayTrigger>
                </td>
                <td style={{align: 'left', width: '28%', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                       <Field
                         name="typeOfExit"
                         hintText="Type Of Exit"
                         style={{width: '100%'}}
                         component={SelectField}>
              <MenuItem value={null} primaryText="&nbsp;" disabled={false} selected={true}/>
              <MenuItem onTouchTap={(e) => {
                    this.setState({serving: 'block', served: 'block', recover: 'block', termination : 'none',
                                      gardeningDisplay: 'none', abscond: 'none', business: 'none'});
              }} value="voluntary" primaryText="Voluntary"/>
              <MenuItem onTouchTap={(e) => {
                  this.setState({serving: 'block', served: 'block', gardeningDisplay: 'block', termination: 'block',
                          recover: 'none', abscond: 'none', business: 'block'});
              }} value="involuntary" primaryText="Involuntary"/>
              <MenuItem onTouchTap={(e) => {
                  this.setState({abscond: 'block', serving:'none', served:'none', recover:'none', termination:'none',
                                  gardeningDisplay: 'none', business: 'none'});
              }} value="abscond" primaryText="Abscond"/>
            </Field>
                  </span>
                </td>
                <td style={{color: 'black', align: 'left', width: '18%'}}>Notice Period Status:</td>
                <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtSpouseName" className="GenText">
                      <Field
                        name="noticePeriodStatus"
                        hintText="Notice Period Status"
                        style={{width: '100%'}}
                        component={SelectField}>
                <MenuItem value={null}
                          onTouchTap={(e) => {
                            this.setState({gardening: true})
                          }}
                          primaryText="&nbsp;" disabled={false} selected={true}/>

                <MenuItem onTouchTap={(e) => {
                  this.setState({gardening: true})
                }} value="Serving" primaryText="Serving" style={{display: this.state.serving}} />

                <MenuItem onTouchTap={(e) => {
                  this.setState({gardening: true})
                }} value="Served" primaryText="Served" style={{display: this.state.served}}/>
                 <MenuItem  onTouchTap={()=> {
                  this.setState({gardening: true})
                }} value="Abscond" primaryText="Abscond" style={{display: this.state.abscond}}/>

                <MenuItem  onTouchTap={()=> {
                  this.setState({gardening: true})
                }} value="Recover" primaryText="Recover" style={{display: this.state.recover}}/>

                <MenuItem  onTouchTap={()=> {
                  this.setState({gardening: true})
                }} value="Gardening" primaryText="Gardening" style={{display: this.state.gardeningDisplay}}/>

                <MenuItem  onTouchTap={()=> {
                    this.setState({gardening: true})
                    alert("Employee will be issued Termination Letter instead of Relieving cum Experience Letter");
                }} value="Termination" primaryText="Termination" style={{display: this.state.termination}}/>

                <MenuItem  onTouchTap={()=> {
                    this.setState({gardening: true})
                }} value="Business" primaryText="Business" style={{display: this.state.business}}/>

                      </Field>
                    </span>
                </td>
              </tr>
              <tr>

              </tr>


              <tr>
                <td style={{color: 'black', align: 'left', width: '18%'}}>Reasons for leaving:</td>
                <td colSpan="3" style={{
                  fontSize: '16px',
                  align: 'left',
                  width: '28%',
                  padding: 0,
                  paddingLeft: '1%',
                  paddingTop: '0%'
                }}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                     <Field
                       name="remarks"
                       rowsMax={2}
                       multiLine={true}
                       hintText="Kindly enter reasons for leaving and remarks if any"
                       style={{width: '100%'}}
                       component={TextField}
                     />
                  </span>
                </td>
              </tr>
              <tr>
              </tr>
              <tr>
                <td style={{color: 'black', align: 'center', width: '18%'}}>{exitText}</td>
                <td style={{align: 'center'}}>
                  <img src={this.state.src} height="200px" width="200px" border={0}/>
                  <div> <b> Note: </b> File size should not be more than 2 MB and format is in jpeg/png/pdf only</div>
                  <div className="uploadButton">
                    <button className="btn btn-default">Upload</button>

                    <input type="file" onChange={(event)=> {
                      let file_size = event.target.files[0].size;
                      let file_type = event.target.files[0].type;
                      if(file_size > Constants.imageSize) {
                        this.setState({src: "", file: ""});
                        alert('File size is too big. Please upload a small size file');
                      }else{
                        if(file_type == "image/jpeg" || file_type == "image/png" || file_type == "application/pdf"){
                          var reader = new FileReader();
                          reader.onload = (e)=> {
                            this.setState({src: e.target.result})
                          };
                          reader.readAsDataURL(event.target.files[0]);
                          this.setState({file: event.target.files[0]})
                        }else{
                          this.setState({src: "", file: ""});
                          alert("File format should be in jpeg/png/pdf only");
                        }
                      }
                    }} name="exitImage" id = "exitImage" className="fileUpload" />
                  </div>
                </td>
              </tr>
              <tr>
              </tr>
              </tbody>
            </table>
            <br/>
            <button type="submit" style={{width: '25%', marginRight: '20px'}} className="btn btn-default">Submit
            </button>
            <button type="button" onClick={reset} style={{width: '20%'}} className="btn btn-default btn-group-lg">
              Reset
            </button>
            <div style={{display: 'none'}}>
              <Field name="gardening"
                     component={DatePicker}
                     disabled={this.state.gardening}
                     autoOk={true}
                     textFieldStyle={{width: '100%'}}
                     defaultValue={null} // DatePicker requires an object,
                // and redux-form defaults to ''
                     floatingLabelText="Gardening Date"
                     hintText="Gardening Date"/>
            </div>
          </form>


          <br/>
          <div style={{display: 'none'}}>
            <button className="btn btn-default btn-block"
                    disabled={this.state.disable}
                    onClick={()=> {
                      if (this.state.doR == null || (this.state.comment == null || this.state.comment == "")) {
                        this.setState({error: 'Required'});
                        toastr.error("Enter date of resignation and remarks");
                      }
                      else {
                        this.setState({disable: true});
                        axios.post(process.env.REQ_URL + "/exit/managerApply", {
                          data: {
                            empId: this.props.employee.employeeCode,
                            remark: this.state.comment == null ? "" : this.state.comment,
                            doResignation: this.state.doR.getTime()
                          }
                        }, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {

                          this.setState({error: "", disable: false})
                          this.props.close();
                          this.props.refresh();
                          toastr.success("Submitted Resignation")

                        }).catch((error) => {
                          this.setState({disable: false});
                          toastr.error("Error Occurred");
                          console.log(error);
                        });
                      }
                    }}>Submit
            </button>
            <br/>
            <button
              onClick={()=> {
                this.props.close();
              }}
              className="btn btn-default btn-block">Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

ModalApply.propTypes = {};

export default reduxForm({
  form: 'applyExitManager',
  validate,

})(ModalApply)





/** WEBPACK FOOTER **
 ** ./src/feature/myProfile/ManagerSS/Modals/ModalApply.js
 **/